var styles = {"tablist":"bc-tabs__tablist","horizontal":"bc-tabs__horizontal","vertical":"bc-tabs__vertical","tab":"bc-tabs__tab","selectedTab":"bc-tabs__selectedTab","tabpanel":"bc-tabs__tabpanel"};

export { styles as default };
